<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SelectMenu from 'dashboard/components-next/selectmenu/SelectMenu.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import { DUE_RANGE } from 'kanban/helper/taskFilters';

defineProps({
  hideLabel: { type: Boolean, default: false },
});

// 'all' | DUE_STATUSES | 'range'; o intervalo usa dueFrom/dueTo ("AAAA-MM-DD").
const dueStatus = defineModel('dueStatus', { type: String, required: true });
const dueFrom = defineModel('dueFrom', { type: String, default: null });
const dueTo = defineModel('dueTo', { type: String, default: null });

const { t } = useI18n();

const options = computed(() => [
  {
    label: t('KANBAN.FILTERS.DUE.ALL'),
    value: 'all',
    icon: 'i-lucide-calendar-clock',
  },
  {
    label: t('KANBAN.FILTERS.DUE.OVERDUE'),
    value: 'overdue',
    icon: 'i-lucide-calendar-x',
  },
  {
    label: t('KANBAN.FILTERS.DUE.DUE_TODAY'),
    value: 'due_today',
    icon: 'i-lucide-calendar-check',
  },
  {
    label: t('KANBAN.FILTERS.DUE.NEXT_7_DAYS'),
    value: 'next_7_days',
    icon: 'i-lucide-calendar-days',
  },
  {
    label: t('KANBAN.FILTERS.DUE.NO_DUE_DATE'),
    value: 'no_due_date',
    icon: 'i-lucide-calendar-off',
  },
  {
    label: t('KANBAN.FILTERS.DUE.RANGE'),
    value: DUE_RANGE,
    icon: 'i-lucide-calendar-range',
  },
]);

const label = computed(() =>
  dueStatus.value === 'all'
    ? t('KANBAN.FILTERS.DUE.LABEL')
    : options.value.find(option => option.value === dueStatus.value)?.label
);

const selectStatus = value => {
  dueStatus.value = value;
  if (value === DUE_RANGE) return;
  dueFrom.value = null;
  dueTo.value = null;
};

// O intervalo nunca fica invertido (a API recusaria): a outra ponta acompanha.
const updateFrom = value => {
  dueFrom.value = value || null;
  if (dueFrom.value && dueTo.value && dueFrom.value > dueTo.value) {
    dueTo.value = dueFrom.value;
  }
};

const updateTo = value => {
  dueTo.value = value || null;
  if (dueFrom.value && dueTo.value && dueFrom.value > dueTo.value) {
    dueFrom.value = dueTo.value;
  }
};
</script>

<template>
  <div class="flex items-center gap-2 shrink-0">
    <SelectMenu
      :model-value="dueStatus"
      :options="options"
      :label="label"
      :hide-label="hideLabel"
      icon="i-lucide-alarm-clock"
      sub-menu-position="bottom"
      max-width="max-w-56"
      @update:model-value="selectStatus"
    />
    <template v-if="dueStatus === DUE_RANGE">
      <span class="text-xs text-n-slate-11">
        {{ t('KANBAN.FILTERS.DUE.FROM') }}
      </span>
      <Input
        :model-value="dueFrom || ''"
        type="date"
        size="sm"
        :max="dueTo || ''"
        @update:model-value="updateFrom"
      />
      <span class="text-xs text-n-slate-11">
        {{ t('KANBAN.FILTERS.DUE.TO') }}
      </span>
      <Input
        :model-value="dueTo || ''"
        type="date"
        size="sm"
        :min="dueFrom || ''"
        @update:model-value="updateTo"
      />
    </template>
  </div>
</template>
